import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { DynamicFeatureFlagService } from 'shared/services';
import {
    ADMIN_HOME_LEGACY,
    ADMIN_HOME_PLATFORM_USERS,
    ADMIN_PLATFORM_FEATURE_FLAG
} from 'app/admin-platform-v2/constants/admin-routes.constants';

/** Resolves the FC Admin home URL based on `enable_admin_platform`. */
export function getAdminHomeUrl(dynamicFeatureFlagService: DynamicFeatureFlagService): Observable<string> {
    return dynamicFeatureFlagService.isFeatureEnabled$(ADMIN_PLATFORM_FEATURE_FLAG).pipe(
        take(1),
        map((enabled) => (enabled ? ADMIN_HOME_PLATFORM_USERS : ADMIN_HOME_LEGACY))
    );
}
